/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_IntroInputs */

const en_services_intro = /** @type {(inputs: Services_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We design and build AI systems that do real work: answering and following up from your own data, finding and researching leads, teams of agents with budgets, research that cites its sources, and complete systems we build and run.`)
};

const lv_services_intro = /** @type {(inputs: Services_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektējam un izstrādājam AI sistēmas, kas paveic īstu darbu: atbild un seko līdzi, izmantojot Jūsu datus, atrod un izpēta potenciālos klientus, vada aģentu komandas ar budžetiem, veic izpēti ar avotiem un darbina pilnas sistēmas, ko izveidojam un uzturam.`)
};

/**
* | output |
* | --- |
* | "We design and build AI systems that do real work: answering and following up from your own data, finding and researching leads, teams of agents with budgets,..." |
*
* @param {Services_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_intro = /** @type {((inputs?: Services_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_intro(inputs)
	return en_services_intro(inputs)
});